import styled from 'styled-components';

export const SectionContainer = styled.section`
  position: relative;
  width: 100%;
  height: ${({ isHome }) => (isHome ? 'auto' : '80vh')};
  background-color: #1a1a1a;
  overflow: ${({ isHome }) => (isHome ? 'visible' : 'hidden')};
  padding: ${({ isHome }) => (isHome ? '10rem 0 10rem 0' : '0')};

  @media (max-width: 768px) {
    height: ${({ isHome }) => (isHome ? 'auto' : '700px')};
    padding: ${({ isHome }) => (isHome ? '3rem 1rem' : '0')};
  }
`;

export const VectorWrapper = styled.div`
  position: relative;
  width: 100%;
  height: ${({ isHome }) => (isHome ? '200px' : '100%')};
  display: ${({ isHome }) => (isHome ? 'flex' : 'block')};
  flex-direction: ${({ isHome }) => (isHome ? 'column' : 'initial')};
  align-items: ${({ isHome }) => (isHome ? 'center' : 'initial')};
  justify-content: ${({ isHome }) => (isHome ? 'center' : 'initial')};
`;

export const VectorContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover .default {
    opacity: 0;
  }

  &:hover .hovered {
    opacity: 1;
  }

  @media (max-width: 768px) {
    width: 80px;
    height: 80px;
  }
`;

export const ContentWrapper = styled.div`
  width: 100%;
  max-width: 1200px; /* controla largura do conteúdo */
  margin: 0 auto; /* centraliza o bloco na página */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center; /* garante que o texto fique centralizado */
  padding: 0 1rem; /* evita que encoste nas laterais em telas pequenas */
`;

export const StyledVector = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  transition: opacity 0.3s ease;

  &.default {
    opacity: 1;
  }

  &.hovered {
    opacity: 0;
  }
`;

export const Title = styled.h1`
  position: ${({ isHome }) => (isHome ? 'relative' : 'absolute')};
  bottom: ${({ isHome }) => (isHome ? 'initial' : '20%')};
  left: ${({ isHome }) => (isHome ? 'initial' : '50%')};
  transform: ${({ isHome }) => (isHome ? 'none' : 'translateX(-50%)')};

  color: #c3c3c3;
  font-size: 2.5rem;
  font-weight: 250;
  line-height: 1.2;
  text-align: center;

  /* REMOVED width:100% because interferia; usar max-width + margin auto */
  max-width: 900px;
  margin: 0 auto 1rem auto; /* centraliza o bloco */

  @media (max-width: 768px) {
    font-size: ${({ isHome }) => (isHome ? '2rem' : '24px')};
    bottom: ${({ isHome }) => (isHome ? 'initial' : '10%')};
    color: ${({ isHome }) => (isHome ? '#e4e4e4' : '#c3c3c3')};
    font-weight: ${({ isHome }) => (isHome ? 300 : 250)};
  }
`;

export const Paragraph = styled.p`
  position: ${({ isHome }) => (isHome ? 'relative' : 'absolute')};
  bottom: ${({ isHome }) => (isHome ? 'initial' : '14%')};
  left: ${({ isHome }) => (isHome ? 'initial' : '50%')};
  transform: ${({ isHome }) => (isHome ? 'none' : 'translateX(-50%)')};

  color: #c3c3c3;
  font-size: 1.2rem;
  font-weight: 300;
  line-height: 1.5;
  text-align: center;

  max-width: 800px;
  margin: 0 auto 2rem auto; /* centraliza e cria espaço embaixo */

  @media (max-width: 768px) {
    font-size: ${({ isHome }) => (isHome ? '1rem' : '1rem')};
    bottom: ${({ isHome }) => (isHome ? 'initial' : '1%')};
  }
`;

export const ExtraContent = styled.div`
  margin-top: 2rem;
  text-align: center;

  img {
    max-width: 100%;
    border-radius: 12px;
  }
`;
